module.exports = __webpack_public_path__ + "static/media/portico-design-group.06dd4f9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portico-design-group.svg
// module id = 371
// module chunks = 0